import { SearchParams } from '../types';

export function calculateDateRange(
  time: string,
  specific: SearchParams['specific']
) {
  if (time === 'specific' && specific) {
    return {
      dateFrom: specific.dateFrom.toISOString(),
      dateTo: specific.dateTo.toISOString()
    };
  }

  const now = new Date();
  const dateFrom = new Date();

  switch (time) {
    case '5 Minutes':
      dateFrom.setMinutes(now.getMinutes() - 5);
      break;
    case '15 Minutes':
      dateFrom.setMinutes(now.getMinutes() - 15);
      break;
    case '30 Minutes':
      dateFrom.setMinutes(now.getMinutes() - 30);
      break;
    case '1 Hour':
      dateFrom.setHours(now.getHours() - 1);
      break;
    case '3 Hours':
      dateFrom.setHours(now.getHours() - 3);
      break;
    case '6 Hours':
      dateFrom.setHours(now.getHours() - 6);
      break;
    case '12 Hours':
      dateFrom.setHours(now.getHours() - 12);
      break;
    case '24 Hours':
      dateFrom.setHours(now.getHours() - 24);
      break;
    case '1 Day':
      dateFrom.setDate(now.getDate() - 1);
      break;
    case '2 Days':
      dateFrom.setDate(now.getDate() - 2);
      break;
    case '3 Days':
      dateFrom.setDate(now.getDate() - 3);
      break;
    default:
      dateFrom.setMinutes(now.getMinutes() - 5);
  }

  return {
    dateFrom: dateFrom.toISOString(),
    dateTo: now.toISOString()
  };
}
